export const DEFAULT_ASPECT_RATIO = 16 / 9;
export const HAND_RAISED_USER_DATA_KEY = 'hr';
export const SIDEBAR_WIDTH = '302';
export const MOBILE_SIDEBAR_WIDTH = '300';
export const SPEAKER_PARTICIPANT_BAR_WIDTH = 192;
